// Network logos
import { Network } from '@manifoldxyz/js-ts-utils';
import { common } from '@manifoldxyz/studio-app-sdk';
import apechainLogo from '@/assets/networks/apechain.svg';
import baseLogo from '@/assets/networks/base.svg';
import defaultLogo from '@/assets/networks/default.svg';
import ethereumLogo from '@/assets/networks/ethereum.svg';
import optimismLogo from '@/assets/networks/optimism.svg';
import polygonLogo from '@/assets/networks/polygon.svg';
import shapeLogo from '@/assets/networks/shape.svg';

/**
 * Get the network logo based on network ID
 */
export function getNetworkLogo(
  networkId: Network.NetworkId | common.Schema.SupportedNetwork,
): string {
  switch (networkId) {
    case Network.NetworkId.Mainnet:
    case Network.NetworkId.Sepolia:
      return ethereumLogo;
    case Network.NetworkId.Matic:
      return polygonLogo;
    case Network.NetworkId.Optimism:
      return optimismLogo;
    case Network.NetworkId.Base:
      return baseLogo;
    case Network.NetworkId.Shape:
      return shapeLogo;
    case Network.NetworkId.ApeChain:
      return apechainLogo;
    default:
      return defaultLogo;
  }
}

export function getSupportedRelayNetworks(isTestnet?: boolean) {
  if (isTestnet) {
    return [Network.NetworkId.Sepolia];
  }
  return [
    Network.NetworkId.Base,
    Network.NetworkId.Optimism,
    Network.NetworkId.Mainnet,
    Network.NetworkId.Shape,
  ];
}
